export default __webpack_public_path__ + "static/media/3.9251c6a1.png";